import * as R from 'ramda';

export default function AssetAdminController(
  $q,
  $scope,
  confirmDialog,
  editAssetDialog,
  ssDialogService,
  assetDataService,
  assetSharedModelService,
  riskSharedModelService,
  assetAdminSettingsDialog,
  loaderService,
) {
  const vm = this;

  vm.appIsLoaded = false;
  vm.showFilters = false;
  vm.groupId = 47;
  vm.assets = [];
  vm.filteredAssetTypes = [];
  vm.assetTypesList = [];

  vm.filters = {
    itAssets: true,
    nonITAssets: true,
  };

  // Remove this when page is secured with permissions
  vm.permissions = [];
  vm.permissions.canImportAssets = true;
  vm.permissions.canGenerateReport = true;

  vm.handleShowAddAssetClick = _handleShowAddAssetClick;
  vm.handleFilterChange = _handleFilterChange;
  vm.handleClearFilters = _handleClearFilters;
  vm.handleShowSettings = _handleShowSettings;
  vm.refreshAssets = _refreshAssets;

  _activate();

  function _activate() {
    _initEventListeners();
    _initPage().then(() => {
      vm.appIsLoaded = true;
    });
  }

  function _handleShowAddAssetClick($event) {
    loaderService.showViewLoader = true;
    const asset = { customerAssetId: 0 };
    ssDialogService.dialogs.assetAdmin.editAssetDialog = ssDialogService.alert(
      editAssetDialog.getOptions($event, {
        asset,
        assetCriticalities: assetSharedModelService.AssetCriticalities,
        assetDataTypes: assetSharedModelService.AssetDataTypes,
        assetDataUses: assetSharedModelService.AssetDataUses,
        assetTypes: assetSharedModelService.AssetTypes,
      }),
    );
    loaderService.showViewLoader = false;
    ssDialogService.show(ssDialogService.dialogs.assetAdmin.editAssetDialog);
  }

  function _handleShowSettings($event) {
    loaderService.showViewLoader = true;
    assetDataService.getAssetTypes().then(getAssetTypesResponse => {
      loaderService.showViewLoader = false;
      const assetTypes = getAssetTypesResponse.data.result.map(assetType => {
        const myAssetType = assetSharedModelService.AssetTypes.find(
          currAssetType => currAssetType.customerAssetTypeId === assetType.customerAssetTypeId,
        );
        let count = 0;
        if (myAssetType) {
          count = myAssetType.customerAssetCount;
        }
        return {
          ...assetType,
          instanceCount: count,
        };
      });
      ssDialogService.dialogs.assetAdmin.assetAdminSettingsDialog = ssDialogService.alert(
        assetAdminSettingsDialog.getOptions($event, {
          assetTypes,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.assetAdmin.assetAdminSettingsDialog);
    });
  }

  function _refreshAssets() {
    return _initPage();
  }

  function _initEventListeners() {
    $scope.$on('refreshAssetTypes', _refreshAssets);
  }

  function _initPage() {
    return assetDataService.initAssetAdmin(false).then(initAssetAdminResponse => {
      vm.customerId = initAssetAdminResponse.data.CustomerID;
      assetDataService.customerId = initAssetAdminResponse.data.CustomerID;

      vm.hasNetComply = initAssetAdminResponse.data.HasNetComply;
      vm.hasEndpointManagement = initAssetAdminResponse.data.HasEndpointManagement;
      vm.rmmReportingSource = initAssetAdminResponse.data.RmmReportingSource;

      // Asset Init Data
      const assetInitData = initAssetAdminResponse.data.CustomerAssetAdministrationInitData;

      if (assetInitData.AssetCriticalities) {
        vm.assetCriticalities = assetInitData.AssetCriticalities.result;
        assetSharedModelService.AssetCriticalities = vm.assetCriticalities;
      }

      if (assetInitData.AssetDataTypes) {
        vm.assetDataTypes = assetInitData.AssetDataTypes.result;
        assetSharedModelService.AssetDataTypes = vm.assetDataTypes;
      }

      if (assetInitData.AssetDataUses) {
        vm.assetDataUses = assetInitData.AssetDataUses.result;
        assetSharedModelService.AssetDataUses = vm.assetDataUses;
      }

      if (assetInitData.AssetTypes) {
        vm.assetTypes = assetInitData.AssetTypes.result;
        assetSharedModelService.AssetTypes = vm.assetTypes;
        vm.filteredAssetTypes = vm.assetTypes;

        vm.assetTypesList = [];
        R.forEach(assetType => {
          const listObj = {
            id: assetType.customerAssetTypeId,
            name: assetType.name,
          };

          vm.assetTypesList.push(listObj);
        }, vm.assetTypes);
      }

      // Risk Init Data
      const riskInitData = initAssetAdminResponse.data.CustomerRiskAdministrationInitData;

      if (riskInitData.RiskOnsets) {
        vm.riskOnsets = riskInitData.RiskOnsets.result;
        riskSharedModelService.RiskOnsets = vm.riskOnsets;
      }

      if (riskInitData.RiskForewarnings) {
        vm.riskForewarnings = riskInitData.RiskForewarnings.result;
        riskSharedModelService.RiskForewarnings = vm.riskForewarnings;
      }

      if (riskInitData.RiskDurations) {
        vm.riskDurations = riskInitData.RiskDurations.result;
        riskSharedModelService.RiskDurations = vm.riskDurations;
      }

      if (riskInitData.RiskDataConfidentialities) {
        vm.riskDataConfidentialities = riskInitData.RiskDataConfidentialities.result;
        riskSharedModelService.RiskDataConfidentialities = vm.riskDataConfidentialities;
      }

      if (riskInitData.RiskDataIntegrities) {
        vm.riskDataIntegrities = riskInitData.RiskDataIntegrities.result;
        riskSharedModelService.RiskDataIntegrities = vm.riskDataIntegrities;
      }

      if (riskInitData.RiskDataAvailabilities) {
        vm.riskDataAvailabilities = riskInitData.RiskDataAvailabilities.result;
        riskSharedModelService.RiskDataAvailabilities = vm.riskDataAvailabilities;
      }

      if (riskInitData.RiskDirections) {
        vm.riskDirections = riskInitData.RiskDirections.result;
        riskSharedModelService.RiskDirections = vm.riskDirections;
      }

      if (riskInitData.RiskTrendings) {
        vm.riskTrendings = riskInitData.RiskTrendings.result;
        riskSharedModelService.RiskTrendings = vm.riskTrendings;
      }

      if (riskInitData.RiskAssessmentFrequencies) {
        vm.riskAssessmentFrequencies = riskInitData.RiskAssessmentFrequencies.result;
        riskSharedModelService.RiskAssessmentFrequencies = vm.riskAssessmentFrequencies;
      }

      if (riskInitData.RiskProbabilities) {
        vm.riskProbabilities = riskInitData.RiskProbabilities.result;
        riskSharedModelService.RiskProbabilities = vm.riskProbabilities;
      }

      if (riskInitData.RiskClassifications) {
        vm.riskClassifications = riskInitData.RiskClassifications.result;
        riskSharedModelService.RiskClassifications = vm.riskClassifications;
      }

      if (riskInitData.CustomerRiskInherentSeverityLevels) {
        vm.customerRiskInherentSeverityLevels = riskInitData.CustomerRiskInherentSeverityLevels.result;
        riskSharedModelService.CustomerRiskInherentSeverityLevels = vm.customerRiskInherentSeverityLevels;
      }

      // const controlInitData = initAssetAdminResponse.data.CustomerControlAdministrationInitData;

      // if (controlInitData.RiskClassifications) {
      //   vm.riskClassifications = controlInitData.RiskClassifications.result;
      //   controlSharedModelService.RiskClassifications = vm.riskClassifications;
      // }
    });
  }

  function _handleFilterChange() {
    _filterAssets();
  }

  function _handleClearFilters() {
    vm.filters = {
      itAssets: true,
      nonITAssets: true,
    };
    _filterAssets();
  }

  function _filterAssets() {
    if (vm.filters.itAssets && vm.filters.nonITAssets) {
      vm.filteredAssetTypes = vm.assetTypes;
    } else if (vm.filters.itAssets && !vm.filters.nonITAssets) {
      vm.filteredAssetTypes = R.filter(R.propEq('isITAsset', true), vm.assetTypes);
    } else if (!vm.filters.itAssets && vm.filters.nonITAssets) {
      vm.filteredAssetTypes = R.filter(R.propEq('isITAsset', false), vm.assetTypes);
    } else {
      vm.filteredAssetTypes = [];
    }
  }
}

AssetAdminController.$inject = [
  '$q',
  '$scope',
  'confirmDialog',
  'editAssetDialog',
  'ssDialogService',
  'assetDataService',
  'assetSharedModelService',
  'riskSharedModelService',
  'assetAdminSettingsDialog',

  'loaderService',
];
